import { render, staticRenderFns } from "./ResetPasswordProfile.vue?vue&type=template&id=87f87e44"
import script from "./ResetPasswordProfile.vue?vue&type=script&lang=js"
export * from "./ResetPasswordProfile.vue?vue&type=script&lang=js"
import style0 from "./ResetPasswordProfile.vue?vue&type=style&index=0&id=87f87e44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports